import { getEmbeddingDomain } from "../environment";
import { EventListItem, Fetched, ImgixCrop, ImgixImage, RequestError } from "../types";
import fetch from "./fetch";
const organizationId = window.ORGANIZATION_ID;

type GenericEventListErrror = { type: "ERROR_FETCHING_EVENT_LIST" };
export type EventListError = GenericEventListErrror;

export const fetchEvents = async (): Promise<
  Fetched<EventListItem[]> | RequestError<EventListError>
> => {
  const response = await fetch(`/api/public/v3.0/organizations/${organizationId}/events`);
  if (response.type !== "success") {
    return {
      status: "error",
      error: {
        type: "ERROR_FETCHING_EVENT_LIST",
      },
    };
  }

  const json = response.response;

  return {
    status: "fetched",
    entity: json.events
      .filter((event: any) => !event.is_cancelled)
      .map((event: any): EventListItem => {
        const imgixImage = event.data.image
          ? ({
              url: event.data.image,
              crop: {
                height: event.data.image_crop.height,
                width: event.data.image_crop.width,
                offsetX: event.data.image_crop.x,
                offsetY: event.data.image_crop.y,
              } as ImgixCrop,
            } as ImgixImage)
          : null;

        return {
          eventId: event.event_id,
          identifier: null,
          title: event.name,
          subtitle: "",
          location: event.data.location.name,
          start: new Date(event.start),
          image: imgixImage,
          images: event.images,
          end: new Date(event.end),
          saleState: event.sale_state,
          dateFormat: event.date_formats
            ? {
                dateText: event.date_formats.date_text,
                dateType: event.date_formats.date_type,
              }
            : {
                dateText: "",
                dateType: "start_date_and_time",
              },
          category: event.data.category,
          availability: event.availability,
        };
      }),
  };
};

export const fetchEventsForEmbedding = async (
  organizationId: string,
): Promise<Fetched<EventListItem[]> | RequestError<EventListError>> => {
  const eventResponse = await fetch(
    `https://api.${getEmbeddingDomain()}/api/public/v3.0/organizations/${organizationId}/events`,
    { mode: "cors" },
  );
  const orgResponse = await fetch(
    `https://api.${getEmbeddingDomain()}/api/public/v3.0/organizations/${organizationId}`,
    { mode: "cors" },
  );
  if (eventResponse.type !== "success" || orgResponse.type !== "success") {
    return {
      status: "error",
      error: {
        type: "ERROR_FETCHING_EVENT_LIST",
      },
    };
  }

  const eventJson = eventResponse.response;
  const orgJson = orgResponse.response;

  return {
    status: "fetched",
    entity: eventJson.events
      .filter((event: any) => !event.is_cancelled)
      .map((event: any): EventListItem => {
        const imgixImage = event.data.image
          ? ({
              url: event.data.image,
              crop: {
                height: event.data.image_crop.height,
                width: event.data.image_crop.width,
                offsetX: event.data.image_crop.x,
                offsetY: event.data.image_crop.y,
              } as ImgixCrop,
            } as ImgixImage)
          : null;

        return {
          eventId: event.event_id,
          identifier: orgJson.identifier,
          title: event.name,
          subtitle: "",
          location: event.data.location.name,
          start: new Date(event.start),
          image: imgixImage,
          images: event.images,
          end: new Date(event.end),
          saleState: event.sale_state,
          dateFormat: event.date_formats
            ? {
                dateText: event.date_formats.date_text,
                dateType: event.date_formats.date_type,
              }
            : {
                dateText: "",
                dateType: "start_date_and_time",
              },
          category: event.data.category,
          availability: event.availability,
        };
      }),
  };
};
